import happyEmojiImage from "../../images/emoji-happy.png";
import mehEmojiImage from "../../images/emoji-meh.png";
import angryEmojiImage from "../../images/emoji-angry.png";
import serverImage from "../../images/server-2.png";
import databaseImage from "../../images/database.png";
import loadBalancerImage from "../../images/load-balancer.png";
import cdnImage from "../../images/cdn.png";
import asgImage from "../../images/auto-scaling-group.png";
import readReplicaImage from "../../images/database-read-replica.png";
import cacheImage from "../../images/redis-cache.png";
import { BlockTypes } from "../../models/block-types";
import lambdaImage from "../../images/lambda.png";
import queueImage from "../../images/queue-icon.png";
import nlbImage from "../../images/network-load-balancer.png";
import noSqlDbImage from "../../images/nosql-db.png";
import graphDbImage from "../../images/graph-db.png";
import documentDbImage from "../../images/document-db.png";
import s3BucketImage from "../../images/s3-bucket.png";
import passthroughImage from "../../images/passthrough.png";
import arrowImage from "../../images/arrow.svg";
import textBoxImage from "../../images/text-box.svg";

const getAltText = (blockType: BlockTypes) => {
  switch (blockType) {
    case BlockTypes.TEXT_BOX:
      return "text box";
    case BlockTypes.USER:
      return "user";
    case BlockTypes.APP_SERVER:
      return "app server";
    case BlockTypes.DATABASE:
      return "database";
    case BlockTypes.LOAD_BALANCER:
      return "load balancer";
    case BlockTypes.CDN:
      return "CDN";
    case BlockTypes.AUTO_SCALING_GROUP:
      return "Auto Scaling Group";
    case BlockTypes.LAMBDA:
      return "lambda";
    case BlockTypes.CACHE:
      return "cache";
    case BlockTypes.DB_READ_REPLICA:
      return "read replica";
    case BlockTypes.QUEUE:
      return "queue";
    case BlockTypes.NETWORK_LOAD_BALANCER:
      return "network load balancer";
    case BlockTypes.NO_SQL_DB:
      return "no sql db";
    case BlockTypes.GRAPH_DB:
      return "graph db";
    case BlockTypes.DOCUMENT_DB:
      return "document db";
    case BlockTypes.S3_BUCKET:
      return "s3 bucket";
    case BlockTypes.PASSTHROUGH:
      return "passthrough";
    case BlockTypes.ARROW:
      return "arrow";
    default:
      return "";
  }
}

const getImage = (blockType: BlockTypes, percentageSuccess?: number) => {
  switch (blockType) {
    case BlockTypes.USER:
      return getUserImage(percentageSuccess);
    case BlockTypes.APP_SERVER:
      return serverImage;
    case BlockTypes.DATABASE:
      return databaseImage;
    case BlockTypes.LOAD_BALANCER:
      return loadBalancerImage;
    case BlockTypes.CDN:
      return cdnImage;
    case BlockTypes.AUTO_SCALING_GROUP:
      return asgImage;
    case BlockTypes.LAMBDA:
      return lambdaImage;
    case BlockTypes.CACHE:
      return cacheImage;
    case BlockTypes.DB_READ_REPLICA:
      return readReplicaImage;
    case BlockTypes.QUEUE:
      return queueImage;
    case BlockTypes.NETWORK_LOAD_BALANCER:
      return nlbImage;
    case BlockTypes.NO_SQL_DB:
      return noSqlDbImage;
    case BlockTypes.GRAPH_DB:
      return graphDbImage;
    case BlockTypes.DOCUMENT_DB:
      return documentDbImage;
    case BlockTypes.S3_BUCKET:
      return s3BucketImage;
    case BlockTypes.PASSTHROUGH:
      return passthroughImage;
    case BlockTypes.ARROW:
      return arrowImage;
    case BlockTypes.TEXT_BOX:
      return textBoxImage;
    default:
      return "";
  }
}

const getUserImage = (percentageSuccess?: number) => {
  let userImage = happyEmojiImage;
  if (percentageSuccess !== undefined) {
    if (percentageSuccess < 75) {
      userImage = angryEmojiImage;
    } else if (percentageSuccess < 90) {
      userImage = mehEmojiImage;
    }
  }

  return userImage;
}

interface Props {
  blockType: BlockTypes;
  width: number;
  height: number;
  percentageSuccess?: number;
}

export const BlockImage: React.FC<Props> = ({
  blockType,
  width,
  height,
  percentageSuccess,
}) => {
  return (
    <img src={getImage(blockType, percentageSuccess)} width={width} height={height} alt={getAltText(blockType)} />
  );
};
